export enum DeliveryStatus {
  AWAITING_EVALUATION = 'AWAITING_EVALUATION',
  PENDING_STUDENT_CORRECTION = 'PENDING_STUDENT_CORRECTION',
  IN_RECOVERY = 'IN_RECOVERY',
  EXPIRED = 'EXPIRED',
  NOT_STARTED = 'NOT_STARTED',
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
}
